import { getData, setData } from "./tokenStorageHelper";

export const getAuthToken = () => {
	const savedSearchAuthToken = getData('CC-Reference');
	if (savedSearchAuthToken) {
		return savedSearchAuthToken;
	}
	return undefined;
};

export const getEmailToken = () => {
	const savedSearchesEmail = getData('CC-Email');
	if (savedSearchesEmail) {
		return savedSearchesEmail;
	}
	return undefined;
};

export const fetchWithAuth = async (url: RequestInfo, options: any = {}) => {
	const init = options;

	const authToken = getAuthToken();
	if (authToken) {
		if (!init.headers) {
			init.headers = {};
		}

		init.headers['CC-Reference'] = `${authToken}`;
	}

	const response = await fetch(url, init);
	if (response.headers.has('CC-Reference')) {
		setData('CC-Reference', response.headers.get('Cc-Reference') ?? '');
	}

	if (response.status === 403) {
		if (response.headers.has('Cc-Email')) {
			setData('CC-Email', response.headers.get('Cc-Email') ?? '');
		}
	}

	return response;
};
